export enum ExpirationDate {
  OneDay = 1,
  SevenDays = 7,
  FourteenDays = 14,
  ThirtyDays = 30,
  SixtyDays = 60,
  NinetyDays = 90,
}
